// Device permission mapping
export const DEVICE_PERMISSIONS = {
  Flood_Stage: {
    view: 'ViewFloodStageConnections',
    delete: 'DeleteFloodStageConnections',
    createEdit: 'Create-EditFloodStageConnections',
  },
  'RescAlert Devices_Manual Road Closure': {
    view: 'ViewRescAlertDevicesManualRoadClosureConnections',
    delete: 'DeleteRescAlertDevicesManualRoadClosureConnections',
    createEdit: 'Create-EditRescAlertDevicesManualRoadClosureConnections',
  },
  'RescAlert Devices_Technology Bridge_Flashing Lights': {
    view: 'ViewRescAlertDevicesTechnologyBridge_FlashingLightsConnections',
    delete: 'DeleteRescAlertDevicesTechnologyBridge_FlashingLightsConnections',
    createEdit: 'Create-EditRescAlertDevicesTechnologyBridge_FlashingLightsConnections',
  },
  'RescAlert Devices_Technology Bridge_Siren/Giant Voice': {
    view: 'ViewRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections',
    delete: 'DeleteRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections',
    createEdit: 'Create-EditRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections',
  },
  'RescAlert Devices_Buoy Conditions': {
    view: 'ViewRescAlertDevicesBuoyConditionsConnections',
    delete: 'DeleteRescAlertDevicesBuoyConditionsConnections',
    createEdit: 'Create-EditRescAlertDevicesBuoyConditionsConnections',
  },
  'Exacq Vision_Camera': {
    view: 'ViewExacqVisionCameraConnections',
    delete: 'DeleteExacqVisionCameraConnections',
    createEdit: 'Create-EditExacqVisionCameraConnections',
  },
  'Exacq Vision_Overwatch VMS': {
    view: 'ViewExacqVisionOverwatchVMSConnections',
    delete: 'DeleteExacqVisionOverwatchVMSConnections',
    createEdit: 'Create-EditExacqVisionOverwatchVMSConnections',
  },
  'USGS Monitoring Station': {
    view: 'ViewUSGSMonitoringStationConnections',
    delete: 'DeleteUSGSMonitoringStationConnections',
    createEdit: 'Create-EditUSGSMonitoringStationConnections',
  },
  // Backwards/alternate key form used elsewhere (`systemType_deviceType`)
  'USGS_Monitoring Station': {
    view: 'ViewUSGSMonitoringStationConnections',
    delete: 'DeleteUSGSMonitoringStationConnections',
    createEdit: 'Create-EditUSGSMonitoringStationConnections',
  },
};

/**
 * Get device permissions for a specific device type
 * @param {string} systemType - The system type (e.g., "Flood", "RescAlert Devices")
 * @param {string} deviceType - The device type (e.g., "Stage", "Camera")
 * @returns {object} - Object containing view, delete, and createEdit permissions
 */
export const getDevicePermissions = (systemType, deviceType) => {
  const key = `${systemType}_${deviceType}`;
  return DEVICE_PERMISSIONS[key] || { view: null, delete: null, createEdit: null };
};

/**
 * Get device permissions from a device object
 * @param {object} device - Device object with system_type and device_type properties
 * @returns {object} - Object containing view, delete, and createEdit permissions
 */
export const getDevicePermissionsFromDevice = (device) => {
  return getDevicePermissions(device?.system_type, device?.device_type);
};

/**
 * Check if user has permission for a specific device action
 * @param {object} perms - Permission object with testPermission method
 * @param {string} systemType - The system type
 * @param {string} deviceType - The device type
 * @param {string} action - The action type ('view', 'delete', 'createEdit')
 * @param {array} roles - Array of role IDs (default: [8, 9, 10, 11, 12, 13])
 * @returns {boolean} - Whether user has permission
 */
export const hasDevicePermission = (
  perms,
  systemType,
  deviceType,
  action,
  roles = [8, 9, 10, 11, 12, 13],
) => {
  // // TEMPORARY: Test with Flood only
  // if (systemType === "Flood") {
  //   return true; // Always allow Flood devices
  // } else {
  //   return false; // Block everything else
  // }

  const permissions = getDevicePermissions(systemType, deviceType);
  const permissionString = permissions[action];

  if (!permissionString) {
    return true; // Default to true if no specific permission defined
  }

  return perms.testPermission(roles, [permissionString]);
};

/**
 * Check if user has permission for a specific device action using device object
 * @param {object} perms - Permission object with testPermission method
 * @param {object} device - Device object with system_type and device_type
 * @param {string} action - The action type ('view', 'delete', 'createEdit')
 * @param {array} roles - Array of role IDs (default: [8, 9, 10, 11, 12, 13])
 * @returns {boolean} - Whether user has permission
 */
export const hasDevicePermissionFromDevice = (
  perms,
  device,
  action,
  roles = [8, 9, 10, 11, 12, 13],
) => {
  return hasDevicePermission(perms, device?.system_type, device?.device_type, action, roles);
};
